import React, { Component } from 'react';

class ShowMoreTrigger extends Component {
	componentDidMount() {
		window.observer = new IntersectionObserver(
			(entries, observer) => {
				entries.forEach((entry) => {
					if (entry.isIntersecting) {
						this.props.callBack();
					}
				});
			},
			{}
		);
		document.querySelectorAll('#last-row').forEach(item => window.observer.observe(item));
	}
	componentWillUnmount() {
		document.querySelectorAll('#last-row').forEach(item => window.observer.observe(item));
	}

	render() {
		const { isLoading, isLoadedAll, compDefault, compLoading, compLoadedAll } = this.props;
		if (isLoading && compLoading) {
			return compLoading;
		}
		if (isLoadedAll) {
			return compLoadedAll || null;
		}

		return (
			compDefault || <span id="last-row">Show more</span>
		);
	}
}

export default ShowMoreTrigger;



// WEBPACK FOOTER //
// ./frontend/admin-dashboard/src/modules/limited-garants/list/components/table/show-more-trigger.js